import React, { useState, useRef } from "react";
import classes from "./Giving.module.css";
//components:
import Button from "../../../UI/Button/Button";
import Modal from "../../../UI/Modal/Modal";
import CurveNameForm from "./GivingForms/CurveNameForm/CurveNameForm";
import LSEForm from "./GivingForms/LSEForm/LSEForm";
import SponsorEventsForm from "./GivingForms/SponsorEventsForm/SponsorEventsForm";
import DonationForm from "./GivingForms/DonationForm/DonationForm";
import AidForm from "./GivingForms/AidForm/AidForm";
//Libraries
//Libraries

const Giving = () => {
  // const container = useRef(null);
  // const card1 = useRef(null);
  // const card2 = useRef(null);
  // const card3 = useRef(null);
  // const card4 = useRef(null);
  // const card5 = useRef(null);

  // const [isCurveModalOpen, setIsCurveModalOpen] = useState(false);
  const [isLSEOpen, setIsLSEOpen] = useState(false);
  const [isSponsorOpen, setIsSponsorOpen] = useState(false);
  const [isDonationOpen, setIsDonationOpen] = useState(false);
  const [isAidOpen, setIsAidOpen] = useState(false);
  const [isAidToDonation, setAidToDonation] = useState(false);

  // const openCurveName = () => {
  //   setIsCurveModalOpen(true);
  // };
  const openLSE = () => {
    setIsLSEOpen(true);
  };
  const openSponsor = () => {
    setIsSponsorOpen(true);
  };
  const openDonation = () => {
    setIsDonationOpen(true);
  };
  const openAid = () => {
    setIsAidOpen(true);
  };
  const cancel = () => {
    // setIsCurveModalOpen(false);
    setIsLSEOpen(false);
    // setIsSponsorOpen(false);
    setIsDonationOpen(false);
    setIsAidOpen(false);
    setAidToDonation(false);
  };

  const aidToDonation = () => {
    setAidToDonation(true);
  };

  return (
    <div className={classes.container}>
      {/* {isCurveModalOpen && (
        <Modal cancel={cancel} title="Curve Your Name" circle={3000} mobile={true}>
          <CurveNameForm></CurveNameForm>
        </Modal>
      )} */}
      {isLSEOpen && (
        <Modal
          cancel={cancel}
          title="SPONSOR A CHILD AT LSE"
          circle={3000}
          mobile={true}
        >
          <LSEForm />
        </Modal>
      )}
      {/* {isSponsorOpen && (
        <Modal cancel={cancel} title="SPONSOR OUR EVENTS" circle={3000} mobile={true}>
          <SponsorEventsForm />
        </Modal>
      )} */}
      {isDonationOpen && (
        <Modal
          cancel={cancel}
          title="Make A Donation"
          circle={3000}
          mobile={true}
        >
          <DonationForm />
        </Modal>
      )}
      {isAidOpen && (
        <Modal cancel={cancel} title="Aid Channel" circle={3000} mobile={true}>
          {isAidToDonation ? (
            <DonationForm />
          ) : (
            <AidForm aidToDonation={aidToDonation} />
          )}
        </Modal>
      )}
      <div>
        <Button
          className={classes.card + " " + classes.pos1}
          // ref={card1}
          backgroundColor={"#265f94"}
          onClick={openLSE}
        >
          <h2>
            Sponsor a Child At <span className={classes.yellow}>LSE</span>
          </h2>
        </Button>
        <Button
          className={classes.card + " " + classes.pos2}
          // ref={card2}
          backgroundColor={"#265f94"}
          onClick={openDonation}
        >
          <h2>
            Make a<span className={classes.yellow}> Donation</span>
          </h2>
        </Button>
        <Button
          className={classes.card + " " + classes.pos3}
          // ref={card3}
          backgroundColor={"#265f94"}
          onClick={openAid}
        >
          <h2>Aid Channel</h2>
        </Button>
        {/* <Button
            className={classes.card + " " + classes.pos4}
            // ref={card4}
            backgroundColor={"#265f94"}
            onClick={openSponsor}
          >
            <h2>
              Sponsor Our 
              Events
            </h2>
          </Button> */}
        {/* <Button
          className={classes.card + " " + classes.pos5}
          // ref={card5}
          backgroundColor={"#265f94"}
          onClick={openCurveName}
        >
          <h2>
            Carve <span className={classes.yellow}>Your</span> Name
          </h2>
        </Button> */}
      </div>
    </div>
  );
};
export default Giving;
